import React, { useState } from 'react';
import api from '../utils/api';
import IconCsvButton from './IconCsvButton';

export default function ExportButton({ endpoint, params = {}, filename = 'export.csv', label = 'Export CSV' }) {
  // Drives the green-check confirmation. The download itself is a blob fetch
  // with no visible navigation, so without this a click looks like nothing
  // happened until the browser's own download shelf catches up.
  const [downloaded, setDownloaded] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleExport() {
    if (busy) return;
    setBusy(true);
    try {
      const query = new URLSearchParams(params).toString();
      const url = query ? `${endpoint}?${query}` : endpoint;
      const { data } = await api.get(url, { responseType: 'blob' });
      const blob = new Blob([data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      setDownloaded(true);
      setTimeout(() => setDownloaded(false), 1500);
    } catch (err) {
      alert('Export failed: ' + (err.response?.data?.error || err.message));
    }
    setBusy(false);
  }

  return (
    <IconCsvButton label={label} done={downloaded} doneLabel="Downloaded"
                   onClick={handleExport} disabled={busy} />
  );
}
